export enum BlockReason {
    FRAUD = 'fraud',
    POSSIBLE_FRAUD = 'possible_fraud',
    DEACTIVATION = 'deactivation',
    TEMP = 'temp',
}